import React, { useState, useEffect } from 'react'
import { Box, Grid, Paper, Flex, ThemeIcon, Anchor, Title, Text } from '@mantine/core'
import { getDataDashboard } from '../../../services/dashboard'
import LoadingData from '../../ui/LoadingData'
import { IconShoppingCart, IconUsersGroup, IconPackages, IconShip, IconSquareCheck } from '@tabler/icons-react'
import { useNavigate } from 'react-router-dom'
import classes from '../../../assets/module-css/AdminLayout.module.css'
import DashboardDivisionCount from './DashboardDivisionCount'
import DashboardStatisticUser from './DashboardStatisticUser'
import DashboardStatsUserGrowth from './DashboardStatsUserGrowth'
import DashboardStatsTotalOrder from './DashboardStatsTotalOrder'
import DashboardStatsCitySignUp from './DashboardStatsCitySignup'
import DashboardStatsSurvey from './DashboardStatsSurvey'
import DashboardStatsRole from './DashboardStatsRole'
import DashboardStatsPlatform from './DashboardStatsPlatform'
import DashboardLatestAbandonedCartItems from './DashboardLatestAbandonedCartItems'


const DashboardCount = () => {
  const navigate = useNavigate()
  const [loadingCount, setLoadingCount] = useState(true)
  const [dataStatistic, setDataStatistic] = useState(null)
  const [dataStatsRole, setDataStatsRole] = useState(null)

  const handleCountDataDashboard = async () => {
    setLoadingCount(true)
    try {
      const response = await getDataDashboard()
      if(response?.data) {
        const result = response.data.managementStats
        const roleUser = result.user.byRoles

        const dataStatuses = result.order.byStatuses

      const findCountWaitingGoodsReady = dataStatuses ? dataStatuses.find(val => val.name === 'waiting goods ready').count : 0
      const findCountWarehouseChecking = dataStatuses ? dataStatuses.find(val => val.name === 'in warehouse checking').count : 0
      const findCountReadyToShip = dataStatuses ? dataStatuses.find(val => val.name === 'ready to ship').count : 0

      const dataAllStatus = [
        ...result.order.byStatuses,
        ...result.order.salesDivision,
        ...result.order.sourcingRequest,
        ...result.order.productQuote,
        ...result.order.nonActive,
      ]

        const statisticData = {
          allOrder : result.order.allCount ? result.order.allCount : 0,
          statuses : dataAllStatus ? dataAllStatus : [],
          role : result.user.byRoles ? result.user.byRoles : [],
          allUser : result.user.allCount ? result.user.allCount : 0,
          allProduct : result.product.allCount ? result.product.allCount : 0,
          sales: result.order.divSalesCount ? result.order.divSalesCount : 0  ,
          logistic: result.order.divLogisticCount ? result.order.divLogisticCount : 0,
          afterSales: result.order.divAftersalesCount ? result.order.divAftersalesCount : 0,
          purchase: result.order.divPurchaseCount ? result.order.divPurchaseCount : 0,
          warehouse: result.order.divWarehouseCount ? result.order.divWarehouseCount : 0,
          warehouseTracking: findCountWaitingGoodsReady + findCountWarehouseChecking + findCountReadyToShip,
          salesDivision: result.order.totalSalesDivision ? result.order.totalSalesDivision : 0,
          sourcingRequest: result.order.totalSourcingRequest ? result.order.totalSourcingRequest : 0,
          productQuote: result.order.totalProductQuote ? result.order.totalProductQuote : 0,
          nonActive: result.order.totalNonActive ? result.order.totalNonActive : 0,
        }
        setDataStatistic(statisticData)

        // eslint-disable-next-line
        const remapRoleStats = roleUser.map((val) => {
          if (
            val.name === 'Basic Member'||
            val.name === 'Premium Member' ||
            val.name === 'VIP Member' ||
            val.name === 'Special Client' ||
            val.name === 'Local Seller' ||
            val.name === 'Verified Seller'
          ) {
            return val
          }
        })

        const filterEmptyRole = remapRoleStats.filter((val) => val !== undefined)

        setDataStatsRole(filterEmptyRole)
      }
    } catch (error) {
      console.error('Error fetching dashboard data:', error)
    } finally {
      setLoadingCount(false)
    }
  }

  useEffect(() => {
    handleCountDataDashboard()
  }, [])

  const mappingCountDashboard = () => {
    const mappingCountHeaderDashboard = (data) => {
      const finishedStatuses = data.statuses.find((item) => item.name === 'finished')
      const finishedCount = finishedStatuses ? finishedStatuses.count : 0
      const defaultDataCount = [
        {
          icon: IconShoppingCart,
          count: `${finishedCount} / ${data.allOrder}`,
          caption: 'Total Finished & All Orders',
          route : '/order/all'
        },
        {
          icon: IconUsersGroup,
          count: data.allUser || 0,
          caption: 'Total Users',
          route : '/users/all'
        },
        {
          icon: IconPackages,
          count: data.allProduct || 0,
          caption: 'Total Products',
          route : '/product/all'
        },
        {
          icon: IconShip,
          count: null,
          caption: 'Total Shipping ( Soon )',
          route : null
        },
        {
          icon: IconSquareCheck,
          count: null,
          caption: 'Total SKU Sold ( Soon )',
          route : null
        },
      ]

      const remapHeaderCount = defaultDataCount.map((val, index) => {
        const handleToPage = (route) => {
          if(route !== null) {
            navigate(route)
          }
        }

        return (
          <Grid.Col span={{ base: 10, md: 2, lg: 2 }} key={index}>
            <Paper withBorder shadow="sm" p="md" radius='md'>
              <Flex justify="space-between" align='start' mb={10}>
                <ThemeIcon variant="light" color="red" radius="xl" size={50}>
                  <val.icon style={{ width: '70%', height: '70%' }} />
                </ThemeIcon>
                <Anchor fz={12} underline="hover" c={val.route !== null ? 'blue' : 'gray.6'} fw='500' onClick={() => handleToPage(val.route)}>See more</Anchor>
              </Flex>
              <Box>
                <Title order={2}>{val.count || '-'}</Title>
                <Text size="xs" color="dimmed">{val.caption}</Text>
              </Box>
            </Paper>
          </Grid.Col>
        )
      })

      return remapHeaderCount
    }


    return (
      <Box>
        <Box mb={30}>
          <Grid columns={10}>
            {mappingCountHeaderDashboard(dataStatistic)}
          </Grid>
        </Box>
        <Box>
          <Text className={classes.titleLayout}>What division are you in right now?</Text>
          <Text size="sm" color="dimmed" mb={24}>The following is the number of orders divided by division in charge</Text>
          <Box my={10}>
            <DashboardDivisionCount statistic={dataStatistic} />
          </Box>
          <Box my={10}>
            <Grid gutter='lg'>
              <Grid.Col span={{ base: 12, md: 6, lg: 6 }}>
                <DashboardStatisticUser />
              </Grid.Col>
              <Grid.Col span={{ base: 12, md: 6, lg: 6 }}>
                <DashboardLatestAbandonedCartItems />
              </Grid.Col>
            </Grid>
          </Box>
          <Box my={10}>
            <Text className={classes.titleLayout}>Performance Monitoring</Text>
            <Text size="sm" color="dimmed" mb={12}>Measure and track In-app Features performance.(Lifetime record)</Text>
            <Box my={10}>
              <Grid gutter='lg'>
                <Grid.Col span={{ base: 12, md: 6, lg: 6 }}>
                  <DashboardStatsCitySignUp />
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 6, lg: 6 }}>
                  <DashboardStatsSurvey />
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 6, lg: 6 }}>
                  <DashboardStatsRole statsRole={dataStatsRole} />
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 6, lg: 6 }}>
                  <DashboardStatsPlatform />
                </Grid.Col>
              </Grid>
            </Box>
          </Box>
          <Box my={10}>
            <DashboardStatsUserGrowth />
          </Box>

          <Box my={10}>
            <DashboardStatsTotalOrder />
          </Box>
        </Box>
      </Box>
    )
  }

  return (
    <Box>
      {loadingCount ? <LoadingData /> : mappingCountDashboard()}
    </Box>
  )
}

export default DashboardCount